import { createSlice } from '@reduxjs/toolkit';
import { createFilterInitialState, filterReducers, FilterState } from 'common/utils/sliceUtils/filterSliceUtils';

type StateWithApplicationSuites = { applicationSuites: FilterState };

const applicationSuitesSlice = createSlice({
    name: 'applicationSuites',
    initialState: createFilterInitialState(),
    reducers: () => ({
        ...filterReducers,
    })
});

// eslint-disable-next-line no-restricted-syntax
export default applicationSuitesSlice.reducer;
export const { addNewFilter, removeFilter, clearFilters } = applicationSuitesSlice.actions;
export const selectFilters = (state: StateWithApplicationSuites) => state.applicationSuites.filters;
